import styled, { css } from 'styled-components';

const StyledButton = styled.button`
  background-color: ${(props) => css`${
    props.active && props.backgroundColor ? props.backgroundColor : 'transparent'
  } !important`};
  border-color: ${(props) => (props.active ? 'transparent !important' : `${props.color} !important`)};
  min-width: 50px;
  white-space: normal;
  padding: 5px;
  border: 1px solid;
  font-size: 14px;
  flex: auto;
  margin: 5px;

  &:hover {
    border-color: transparent !important;
    background-color: ${(props) => css`${props.hoverBackgroundColor} !important`};
    color: ${(props) => css`${props.hoverColor} !important`};
  }

  &:focus {
    outline:none !important;
  }
`;

export default StyledButton;
